import { AccessProtectedPage } from './AccessProtectedPage';
import { ProductType } from 'types';
import { useCallback } from 'react';
import OptionsCalculatorContainer from './components/OptionsCalculatorContainer';
import { OptionsCalculatorProvider } from 'hooks/optionsCalculator/OptionsCalculatorContextProvider';

export const OptionsCalculatorPage = () => {
  return (
    <AccessProtectedPage
      productType={ProductType.OPTIONS_CALCULATOR}
      renderContent={useCallback(
        () => (
          <OptionsCalculatorProvider>
            <OptionsCalculatorContainer />
          </OptionsCalculatorProvider>
        ),
        [],
      )}
    />
  );
};
